// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__T34J4","loader":"MediumLoader_loader__6CGhJ","spinner-c7wet2":"MediumLoader_spinner-c7wet2__IwGHs"};